// Shared cache key — kept as a constant so any other component that wants
// to invalidate the user list (e.g. an audit log row showing recent admin
// changes) can import + reuse the same key without drift.
//
// Lives in a separate non-component module so Vite's React Fast-Refresh
// can keep working on `UsersAdminTab.tsx` (Fast-Refresh requires a file to
// export only React components).
export const USERS_QUERY_KEY = ["admin", "users"] as const;
